window.$ = window.jQuery;
import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";

import Page from "webPage/Page";
import {handleStickyNav} from "util/handleStickyNav";
import Gallery from "webPage/Gallery";
import PageAnimations from "webPage/PageAnimations";
import {handleParallaxSections} from "util/parallax";


$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    PageAnimations.start();
    handleStickyNav();
    Page.init();

    $('body').on('click', '.js-toggle-nav', () => {
        $('body').toggleClass('nav-active');
        return false;
    }).on('click', '.js-book-now-btn, .navigation__item--201 .navigation__link, .footer-nav__item--201 .footer-nav__link', function () {
        $('body').addClass('modal-active');
        $('.js-book-now').addClass('modal--active');

        return false;
    }).on('click', '.js-close-modal', function () {
        $('body').removeClass('modal-active');
        $('.js-book-now').removeClass('modal--active');
    });

    let $gallery = $('.js-review-track-wrap');

    if ($gallery.length > 0) {
        new Gallery($gallery, {
            itemClass: "eotw-reviews-slider__item",
            pipClass: "eotw-reviews-slider__pip",
            navigateClass: "js-track-navigation",
            pipsClass: "js-pips",
            itemsClass: "js-items",
            itemActiveModifier: "active",
            pipActiveModifier: "active",
            animationDuration: 200,
        });
    }


    //We hide the newsletter text once newsletter form has been submitted.
    $(document).on("gform_confirmation_loaded", function (e, form_id) {
        $('.newsletter__text').hide();
    });

    setTimeout(function () {
        handleParallaxSections();
    }, 300);
});

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/avery-berkel-core/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
